import { Typography } from '@xprog/prensa'

export const SideMenuSectionTitle: React.FC<any> = (props) => {
  return (
    <Typography
      as='p'
      css={{
        color: props.color,
        fontFamily: '$primary',
        fontSize: '$retrancaHamburger',
        fontWeight: '$retrancaHamburger',
        lineHeight: '$retrancaHamburger',
        m: '0px',
        pl: '$8',
        pt: '$3',
        pb: '$3',
        textAlign: 'left',
        width: '100%',
      }}
      {...props}
    >
      {props.children}
    </Typography>
  )
}

SideMenuSectionTitle.defaultProps = {
  color: '$primaryMain'
}